import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { AppShell } from './components/layout/AppShell';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import ContactProfile from './pages/ContactProfile';
import Lists from './pages/Lists';
import Events from './pages/Events';
import LandingManager from './pages/LandingManager';
import Subscribers from './pages/Subscribers';
import Unsubscribed from './pages/Unsubscribed';
import EventNew from './pages/EventNew';
import EventDetail from './pages/EventDetail';
import PublicEvent from './pages/PublicEvent';
import PublicSignup from './pages/PublicSignup';
import Unsubscribe from './pages/Unsubscribe';
import AcceptInvite from './pages/AcceptInvite';
import Settings from './pages/Settings';
import Guide from './pages/Guide';
import Landing from './pages/Landing';
import './App.css';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/contacts" element={<Protected><Contacts /></Protected>} />
            <Route path="/app/contacts/:id" element={<Protected><ContactProfile /></Protected>} />
            <Route path="/app/lists" element={<Protected><Lists /></Protected>} />
            <Route path="/app/events" element={<Protected><Events /></Protected>} />
            <Route path="/app/landing" element={<Protected><LandingManager /></Protected>} />
            <Route path="/app/subscribers" element={<Protected><Subscribers /></Protected>} />
            <Route path="/app/unsubscribed" element={<Protected><Unsubscribed /></Protected>} />
            <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/app/guide" element={<Protected><Guide /></Protected>} />
            <Route path="/app/events/new" element={<Protected><EventNew /></Protected>} />
            <Route path="/app/events/:id" element={<Protected><EventDetail /></Protected>} />
            <Route path="/e/:slug" element={<PublicEvent />} />
            <Route path="/signup/:listSlug" element={<PublicSignup />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/admin-invite" element={<AcceptInvite />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
